var map = {
	"./budacom-logo.png": 62208,
	"./buk-logo.png": 35992,
	"./fintoc-logo.png": 83368,
	"./platanus-logo.png": 32457,
	"./platanus-ventures-logo.png": 1654,
	"./plutto-logo.png": 73686,
	"./reversso-logo.png": 97481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59209;